import { useEffect } from "react";
import { getClientSettings } from "../users/service/userApi";
import { setRuntimeFlags } from "./runtimeFlags";
import { useUser } from "../users/providers/UserProvider";

/**
 * Asks the server which flags are in force, once per session.
 *
 * Renders nothing. Mounted below ApiInterceptor so its request carries the
 * auth header, and keyed on the token because /settings/client is behind
 * `auth` — a signed-out visitor has nothing to ask with, and keeps the
 * compiled-in default until they sign in.
 *
 * Failure is silent by design: `getClientSettings` resolves to `{}`, which
 * leaves the build-time value in place. That is exactly the behaviour the app
 * had before the endpoint existed, so an unreachable settings route degrades
 * to the old world rather than to a broken one.
 */
const RuntimeFlagsLoader = () => {
  const { token } = useUser();

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;

    (async () => {
      const settings = await getClientSettings();
      if (!cancelled) setRuntimeFlags(settings);
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return null;
};

export default RuntimeFlagsLoader;
